import { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { NAV } from '../lib/content';
import { Mark } from './LogoMark';
import { ThemeToggle } from './ThemeToggle';

export function Navbar() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    document.documentElement.style.overflow = open ? 'hidden' : '';

    return () => {
      document.documentElement.style.overflow = '';
    };
  }, [open]);

  return (
    <header className="site-header">
      <div className="container-wide site-header__inner">
        <Link to="/" className="brand-lockup" aria-label="Morrow — home">
          <Mark className="brand-lockup__mark" />
          <span className="brand-lockup__word">Morrow</span>
        </Link>

        <nav aria-label="Primary" className="primary-nav">
          {NAV.map((item) => (
            <NavLink
              key={item.href}
              to={item.href}
              end={item.href === '/'}
              className={({ isActive }) => `nav-link ${isActive ? 'nav-link-active' : ''}`}
            >
              {item.label}
            </NavLink>
          ))}
          <Link to="/install" className="btn-primary btn-sm">
            Install
          </Link>
        </nav>

        <div className="header-actions">
          <ThemeToggle />
          <button
            type="button"
            className="menu-toggle"
            onClick={() => setOpen((value) => !value)}
            aria-expanded={open}
            aria-label={open ? 'Close menu' : 'Open menu'}
          >
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true">
              {open ? (
                <path d="M4 4l10 10M14 4L4 14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
              ) : (
                <path d="M2 5h14M2 9h14M2 13h14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
              )}
            </svg>
          </button>
        </div>
      </div>

      {open && (
        <div className="mobile-nav">
          <nav aria-label="Mobile" className="container-wide mobile-nav__inner">
            {NAV.map((item) => (
              <NavLink
                key={item.href}
                to={item.href}
                end={item.href === '/'}
                className={({ isActive }) => `mobile-nav__link ${isActive ? 'active' : ''}`}
              >
                {item.label}
              </NavLink>
            ))}
            <Link to="/install" className="btn-primary mt-3 w-full">
              Install
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}
